/* src/app/modules/patternmatch/components/mrq-mobile-table/mrq-mobile-table.component.scss */
.mobile-table table {
  width: 100%;
  table-layout: fixed;
}
.mobile-table .mat-mdc-header-cell {
  font-weight: bold;
}
.mobile-table .mat-mdc-header-cell:nth-child(1) {
  width: 50%;
}
.mobile-table .mat-mdc-header-cell:nth-child(2) {
  width: 35%;
}
.mobile-table .mat-mdc-header-cell:nth-child(3) {
  width: 15%;
}
.mobile-table .mat-mdc-cell:nth-child(1) {
  width: 50%;
  font-weight: bold;
}
.mobile-table .mat-mdc-cell:nth-child(2) {
  width: 35%;
}
.mobile-table .mat-mdc-cell:nth-child(3) {
  width: 15%;
  text-align: center;
}
.clickable-icon {
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.clickable-icon:hover {
  opacity: 0.7;
}
.clickable-icon:active {
  opacity: 0.5;
}
/*# sourceMappingURL=mrq-mobile-table.component.css.map */
